(() => {
    const hero = document.querySelector('.block-hero');
    if (!hero) return;
    const inner = hero.querySelector('.block-hero__inner');
    if (!inner) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    let ticking = false;

    const update = () => {
        const fadeRange = hero.offsetHeight * 0.5;
        if (fadeRange <= 0) {
            ticking = false;
            return;
        }
        const scrolled = window.scrollY;
        const progress = Math.min(1, Math.max(0, scrolled / fadeRange));
        inner.style.setProperty('--block-hero-opacity', String(1 - progress));
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener('resize', () => {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    update();
})();
